import { Form } from "@circle-react-uikit/Form";

import { useUpdateComment } from "@/react/components/CommentsCompass/data/useUpdateComment";
import { isAuthorAiAgent } from "@/react/components/CommentsCompass/helpers";
import type { TiptapFormValues } from "@/react/components/CommentsCompass/types";
import { useModal } from "@/react/components/Layout/ModalManagerProvider";
import type { Comment } from "@/react/types/Comment";

import { FORM_ID, TiptapEditBody } from "./TiptapEditBody";

interface TiptapEditModalProps {
  comment: Comment;
  spaceId: number;
}

export const TiptapEditModal = ({ comment, spaceId }: TiptapEditModalProps) => {
  const modal = useModal();
  const { updateComment } = useUpdateComment({
    comment,
    onSuccess: () => void modal.hide(),
  });

  return (
    <Form<TiptapFormValues>
      id={FORM_ID}
      defaultValues={{ tiptap_body: comment.tiptap_body }}
      onSubmit={async formData => {
        await updateComment(formData);
      }}
      preventAccidentalLeave
    >
      <TiptapEditBody
        shouldSupportTables={isAuthorAiAgent(comment)}
        spaceId={spaceId}
      />
    </Form>
  );
};
